import Nullstack from 'nullstack';
export default function IconReceiptOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-receipt-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M5 21v-16m2 -2h10a2 2 0 0 1 2 2v10m0 4.01v1.99l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2"
  }), "   ", Nullstack.element("line", {
    x1: "11",
    y1: "7",
    x2: "15",
    y2: "7"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "11",
    x2: "11",
    y2: "11"
  }), "   ", Nullstack.element("line", {
    x1: "13",
    y1: "15",
    x2: "15",
    y2: "15"
  }), "   ", Nullstack.element("line", {
    x1: "15",
    y1: "11",
    x2: "15",
    y2: "11.01"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "3",
    x2: "21",
    y2: "21"
  }), " ");
}